module.exports = __webpack_public_path__ + "static/ui1-4b0cf859ecc3d8fbee3ba5db093afaf9.mp3";